var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-form"
  }, [_c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'contactPerson',
      "options": _vm.getOwnerChoices(),
      "init-value": _vm.propertyInfo.contactPerson.majitel,
      "normal": "",
      "name": 'Objednávateľ'
    },
    on: {
      "select": function select($event) {
        _vm.contactPersonHelper = $event;
      }
    }
  })], 1), _vm.contactPersonHelper === 'other' ? _c('div', [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.objednavatel_meno,
      expression: "form.objednavatel_meno"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "objednavatelMeno",
      "placeholder": "",
      "id": "objednavatelMeno",
      "required": ""
    },
    domProps: {
      "value": _vm.form.objednavatel_meno
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "objednavatel_meno", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.objednavatel_email,
      expression: "form.objednavatel_email"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "objednavatelEmail",
      "placeholder": "",
      "id": "objednavatelEmail",
      "required": ""
    },
    domProps: {
      "value": _vm.form.objednavatel_email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "objednavatel_email", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.objednavatel_telefon,
      expression: "form.objednavatel_telefon"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "objednavatelTelefon",
      "placeholder": "",
      "id": "objednavatelTelefon",
      "required": ""
    },
    domProps: {
      "value": _vm.form.objednavatel_telefon
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "objednavatel_telefon", $event.target.value);
      }
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'contactPerson',
      "options": _vm.getOwnerChoices(),
      "init-value": _vm.propertyInfo.contactPerson.majitel,
      "normal": "",
      "name": 'Kontaktná osoba'
    },
    on: {
      "select": function select($event) {
        _vm.ownerHelper = $event;
      }
    }
  })], 1), _vm.ownerHelper === 'other' ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.majitel_meno,
      expression: "form.majitel_meno"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "majitelMeno",
      "placeholder": "",
      "id": "majitelMeno",
      "required": ""
    },
    domProps: {
      "value": _vm.form.majitel_meno
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "majitel_meno", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.majitel_email,
      expression: "form.majitel_email"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "majitelEmail",
      "placeholder": "",
      "id": "majitelEmail",
      "required": ""
    },
    domProps: {
      "value": _vm.form.majitel_email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "majitel_email", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.majitel_telefon,
      expression: "form.majitel_telefon"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "majitelTelefon",
      "placeholder": "",
      "id": "majitelTelefon",
      "required": ""
    },
    domProps: {
      "value": _vm.form.majitel_telefon
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "majitel_telefon", $event.target.value);
      }
    }
  })])]) : _vm._e(), _vm._m(6)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "objednavatelMeno"
    }
  }, [_vm._v("Meno"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "objednavatelEmail"
    }
  }, [_vm._v("Email"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "objednavatelTelefon"
    }
  }, [_vm._v("Telefón"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "majitelMeno"
    }
  }, [_vm._v("Meno"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "majitelEmail"
    }
  }, [_vm._v("Email"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "majitelTelefon"
    }
  }, [_vm._v("Telefón"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "sprava"
    }
  }, [_vm._v("Správa pre znalca")]), _c('textarea', {
    staticClass: "text-input w-input date-input",
    attrs: {
      "id": "sprava",
      "required": ""
    }
  })]);

}]

export { render, staticRenderFns }